export const DATES = {
  USER_TIMESTAMP: new Date().getTime(),
  SERVICE_TIMESTAMP: new Date().getTime(),
};

export default DATES;
